import { Fragment } from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import CommunicationsPage from './CommunicationsPage';

const CommunicationsWrapper = () => {
    return (
        <Fragment>
            <PageHeader
                title="Comunicaciones"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Comunicaciones', href: menuRoutes.calls.path + menuRoutes.calls.communications },
                ]}
            />
            <CommunicationsPage />
        </Fragment>
    );
};

export default CommunicationsWrapper;
